import PropTypes from "prop-types";
import remove from "lodash/remove";
import find from "lodash/find";
import { Component } from "react";
import { connect } from "react-redux";
import { sendTagOnError } from "app/utils/analytics";

// Voir  https://github.com/michaelwittig/node-i18n-iso-countries/blob/master/langs/fr.json pour la liste des pays

const injectCountries = DecoratedComponent => {
	class InjectCountries extends Component {
		constructor(props) {
			super(props);
			this.state = {
				countries: [],
			};
		}

		componentDidMount() {
			const [locale, countryCode] = this.props.shop.split("-");
			import(`./countries/${locale}.json`)
				.then((countries = []) => {
					// trie par nom de pays
					let finalCountries = [...countries.default].sort((a, b) =>
						a.name.localeCompare(b.name, locale)
					);
					let country = find(finalCountries, { cca2: countryCode });
					if (country) {
						remove(finalCountries, country);
						finalCountries = [country, ...finalCountries];
					}
					this.setState({ countries: finalCountries });
				})
				.catch(error => {
					// eslint-disable-next-line no-console
					console.log(error);
					sendTagOnError(error);
				});
		}

		render() {
			return <DecoratedComponent {...this.props} countries={this.state.countries} />;
		}
	}

	InjectCountries.propTypes = {
		shop: PropTypes.string,
	};

	const mapStateToProps = state => {
		return {
			shop: state.shop,
		};
	};

	return connect(mapStateToProps)(InjectCountries);
};

export default injectCountries;
